// src/components/Footer.jsx
import React from "react";
import { FaLinkedin, FaInstagram, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  const googleMapsLink = "https://maps.app.goo.gl/dRRkydgWLij8moGC6";

  return (
    <footer className="footer bg-gray-900 text-white py-10">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="footer-content grid gap-8 md:grid-cols-4">
          {/* About Section */}
          <div className="footer-about">
            <h3 className="text-xl font-bold mb-3">ABDULHADI AL-AFOO W.L.L</h3>
            <p className="text-sm text-gray-300 mb-4">
              A leading contractor in Bahrain specializing in civil construction,
              sewerage systems, electro-mechanical works, and infrastructure
              development since 1961.
            </p>
            <div className="social-links flex gap-4 text-lg">
              <a
                href="https://www.linkedin.com/company/abdul-hadi-al-afoo-wll/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.instagram.com/alafoo.bh/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-500"
              >
                <FaInstagram />
              </a>
              <a
                href={googleMapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-red-500"
              >
                <FaMapMarkerAlt />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#home" className="hover:text-blue-400">Home</a></li>
              <li><a href="#departments" className="hover:text-blue-400">Departments</a></li>
              <li><a href="#leadership" className="hover:text-blue-400">Leadership</a></li>
              <li><a href="#contact" className="hover:text-blue-400">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-services">
            <h4 className="font-semibold mb-3">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li>Civil Construction</li>
              <li>Sewerage & Drainage</li>
              <li>Micro Tunneling</li>
              <li>Electro-Mechanical Works</li>
              <li>Electrical Infrastructure</li>
              <li>Road & Traffic Solutions</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="font-semibold mb-3">Contact Us</h4>
            <p className="text-sm"><strong>Phone:</strong> +973 17874756</p>
            <p className="text-sm"><strong>Fax:</strong> +973 17874754</p>
            <p className="text-sm"><strong>Email:</strong> alafoo@batelco.com.bh</p>
            <p className="text-sm"><strong>Hours:</strong> Sun-Thu: 7AM-4PM</p>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-bottom text-center mt-10 border-t border-gray-700 pt-4 text-sm text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} ABDULHADI AL-AFOO W.L.L. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
